<template>
    <input
        type="number"
        v-bind:value="value"
        v-on:input="$emit('input', $event.target.value)"
        v-on:change="$emit('filled-out', $event.target.value)"
        v-on:blur="$emit('filled-out', $event.target.value)"
    >
</template>

<script>
  export default {
    props: {
      value: null,
      field: {},
    },
  };
</script>
